module.exports = __webpack_public_path__ + "static/media/lock-closed.3d1e2b76.svg";